import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const PlayerList = ({ players }) => {
    return (
        <div className='s4g-player-list'>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography><b>Se anmälda spelare:</b></Typography>
                </AccordionSummary>
                <AccordionDetails>
                    {players && players.length > 0 &&
                        <ul className='ul-no-bullets'>
                            {players.sort((a, b) => a.name.localeCompare(b.name)).map((player) => (<li key={player.name}>{player.name}</li>))}
                        </ul>}
                    {(!players || players.length === 0) && <p>Inga spelare är anmälda till denna tävling ännu.</p>}
                </AccordionDetails>
            </Accordion>
        </div>
    );
}

export default PlayerList;